export default "__VITE_ASSET__ABqP5QHC__"